/**
 * Boards selectors
 */

import { RootState } from "types";

import { createSelector } from "@reduxjs/toolkit";
import { initialState } from "./initialState";

// TODO: Add an explanation for this
const selectDomain = (state: RootState) => state?.appHomeState || initialState;
export const selectUserDetailsDrawerOpen = createSelector(
  [selectDomain],
  (state) => state.drawerOpen,
);

export const selectAppState = createSelector([selectDomain], (state) => state);

export const selectIsAuthenticated = createSelector(
  [selectDomain],
  (AppState) => AppState.isAuthenticated,
);
export const selectUserFormData = createSelector(
  [selectDomain],
  (AppState) => AppState.userFormData,
);
export const selectWorkSpaceDetails = createSelector(
  [selectDomain],
  (AppState) => AppState.workSpaceDetails,
);
export const selectSelectedTeam = createSelector(
  [selectDomain],
  (AppState) => AppState.selectedTeam,
);
export const selectWorkspaceTeamsSetting = createSelector(
  [selectDomain],
  (AppState) => AppState.workspaceTeamsSetting,
);
export const selectTicketTypes = createSelector(
  [selectDomain],
  (AppState) => AppState.projectSettingDetails.ticketTypes,
);

export const selectIsBoardLoading = createSelector(
  [selectDomain],
  (AppState) => AppState.isBoardLoading,
);

export const selectTicketStatus = createSelector(
  [selectDomain],
  (AppState) => AppState.projectSettingDetails?.ticketStatuses,
);

export const selectTagList = createSelector(
  [selectDomain],
  (AppState) => AppState.projectSettingDetails.ticketTags,
);
export const selectBoardUpdateOrder = createSelector(
  [selectDomain],
  (AppState) => AppState.boards,
);

/// old data
export const selectIsBoardCreate = createSelector(
  [selectDomain],
  (AppState) => AppState.isBoardCreate,
);

export const selectAuthorizedAccounts = createSelector(
  [selectDomain],
  (AppState) => AppState.authorizedAccounts,
);

export const selectLoading = createSelector(
  [selectDomain],
  (AppState) => AppState.loading,
);
export const selectError = createSelector(
  [selectDomain],
  (AppState) => AppState.error,
);

export const selectProjectDetails = createSelector(
  [selectDomain],
  (AppState) => AppState.project,
);

export const selectUserOnboardingStage = createSelector(
  [selectDomain],
  (AppState) => AppState.userOnboardingProgress,
);

export const selectToken = createSelector(
  [selectDomain],
  (AppState) => AppState.access_token,
);

export const selectIsBoardMenuLoading = createSelector(
  [selectDomain],
  (AppState) => AppState.isBoardMenuLoading,
);
export const selectBoardMenuData = createSelector(
  [selectDomain],
  (AppState) => AppState.boardMenuData,
);
export const selectIsArchiveLoading = createSelector(
  [selectDomain],
  (AppState) => AppState.isArchiveLoading,
);
export const selectIsCollapseSidebarMenu = createSelector(
  [selectDomain],
  (AppState) => AppState.isCollapseSidebarMenu,
);
export const selectCreateTeamModal = createSelector(
  [selectDomain],
  (state) => state.createTeamModal,
);

export const selectCreateProjectModal = createSelector(
  [selectDomain],
  (state) => state.createProjectModal,
);

export const selectSelectedTeamLoading = createSelector(
  [selectDomain],
  (state) => state.selectedTeamLoading,
);
export const selectProjectSettingDetails = createSelector(
  [selectDomain],
  (state) => state.projectSettingDetails,
);
export const selectSearchDrawerOpen = createSelector(
  [selectDomain],
  (state) => {
    return state.globalSearchModal;
  },
);

export const selectNotificationDrawerOpen = createSelector(
  [selectDomain],
  (state) => state.notificationDrawerOpen,
);

export const selectIsTimeSheetEnabled = createSelector(
  [selectDomain],
  (state) => state.isTimeSheetEnabled,
);

export const selectTimeTracker = createSelector(
  [selectDomain],
  (state) => state.timeTracker,
);
